import building from "../image/building.svg"
import BookData from "./../data/bookData.json"

const CurrentlyBuilding = () => {
    return ( 
        <div className="building">
            <img src= {building} alt= 'BRUH'></img>
            <p>We are still building...</p>

        </div>
     );
}
 
export default CurrentlyBuilding;